import * as React from 'react';

export class TopNavMenu extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    public render() {

        return (
            <div className="top-nav">
                <div className="top-nav-row">
                    <div className="top-nav-right">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/TopNavMenu.tsx